// @flow
import { createSelector, Selector } from 'reselect';
import { GET_USER_RIGHTS_BY_ORGS } from '../actions/access-groups.js';

import { LOGOUT, RESET_CACHE } from '../actions-types/login-action-types.js';

export default function AccessGroupsReducer(state = {}, action) {
  switch (action.type) {
    case GET_USER_RIGHTS_BY_ORGS:
      return {
        ...state,
        accessGroups: {
          ...state.accessGroups,
          ...action.payload.data.groups
        }
      };
    case LOGOUT:
    case RESET_CACHE:
      return {};
    default:
      return state;
  }
}

/**
 * Access group selector
 * @param  {object} state          redux state
 * @param  {string} organizationID organization id for selecting
 * @return {object}                organization access rights
 */
export function selectRightsByOrg(state, organizationID) {
  if (
    state.AccessGroupsReducer &&
    state.AccessGroupsReducer.accessGroups &&
    state.AccessGroupsReducer.accessGroups[organizationID]
  ) {
    return state.AccessGroupsReducer.accessGroups[organizationID];
  }
  return {};
}

const getEvent = (state, props) => state.CalendarReducer.Calendar.events[props.eventID];
const getAircraft = (state, props) => state.ResourceReducer.resources[props.aircraftID];
const getAccessGroups = state => state.AccessGroupsReducer.accessGroups;

export const selectShowCounters: Selector<ReduxState, void, Option[]> = createSelector(
  getEvent,
  getAircraft,
  getAccessGroups,
  (event, aircraft, accessGroups) => {
    const organizationAccess = accessGroups[event.organizationID];
    const hasAccessMeterView = organizationAccess ? organizationAccess.meterView : false;
    return hasAccessMeterView && (aircraft.enableHobbs || aircraft.enableTachometers);
  }
);
